import {useShopActionQuery} from '../../internal/reactQuery'
import {useShopActions} from '../../internal/useShopActions'
import {
  DataHookOptionsBase,
  DataHookReturnsBase,
  UserProfile,
} from '../../types'

export interface UseCurrentUserParams extends DataHookOptionsBase {}

export interface UseCurrentUserReturns extends DataHookReturnsBase {
  /**
   * The current user logged into Shop.
   */
  currentUser: UserProfile | null
}

/**
 * Hook to fetch the current user's profile.
 */
export const useCurrentUser = (
  params?: UseCurrentUserParams
): UseCurrentUserReturns => {
  const {skip, ...shopActionParams} = params || {}
  const {getCurrentUser} = useShopActions()

  const {data, ...rest} = useShopActionQuery(
    ['currentUser', shopActionParams],
    getCurrentUser,
    shopActionParams,
    {skip}
  )

  return {
    ...rest,
    currentUser: data,
  }
}
